import gql from 'graphql-tag';

const QUERY_HOMECARDS = gql`
  query Homecards($ids: [Int], $locale: String = "en") {
    homecards(homecardIds: $ids, locale: $locale) {
      checked
      currencyIsoCode
      firstAvailableDate
      id
      city
      isInstantBooking
      noSecurityDeposit
      isFavorite
      mainPhotoUrl
      monthlyPrice {
        fixedPrice
        minimumPrice
        pricesByMonth {
          jan
          feb
          mar
          apr
          may
          jun
          jul
          aug
          sep
          oct
          nov
          dec
        }
        type
      }
      reviews {
        ratingAverage
      }
      title
      description
      type
      url
      features
      area
      roomArea
      offers {
        discountType
        discountValue
      }
      allowsPermanentContract
      numberOfBathrooms
      numberOfBedrooms
      isBestChoice
      plan
      bills
      location
      photoIds
      displayPrice
    }
  }
`;

const getHomecardsQuery = client => (ids, locale) =>
  client.query({
    query: QUERY_HOMECARDS,
    variables: { ids, locale },
    fetchPolicy: 'cache-first'
  });

export default getHomecardsQuery;
